import { Component, Input, inject } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RoleService } from '../../../Model/Role/role.service';
import { ComboService } from '../../../Model/Combo/combo.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { CommonService } from '../../../Model/Common/common.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';

@Component({
  selector: 'app-role-form',
  standalone: true,
  imports: [FormsModule, CommonModule, NgSelectModule],
  templateUrl: './role-form.component.html',
  styleUrl: './role-form.component.scss'
})
export class RoleFormComponent {
  isDisabled: boolean = false;
  activeModal = inject(NgbActiveModal);
  @Input() id!: number;
  filter = {
    SelectType: 'S',
    WebESSRoleMasterId: 0
  }
  RoleDetail = {
    SelectType: 'I',
    WebESSRoleMasterId: 0,
    RoleName: null,
    UserMasterId: null as any,
    UserMasterIdObj: null as any,
  }
  Users = [] as any;
  UsersFilter = [] as any;

  constructor(
    private role: RoleService,
    private modalService: NgbModal,
    private toast: ToastService,
    private combo: ComboService,
    protected common: CommonService,
    private tooltip: TooltipService,
  ) {
    this.common.getPageRights();
    this.RoleDetail.WebESSRoleMasterId = this.id
    this.filter.WebESSRoleMasterId = this.id
  }

  ngOnInit(): void {
    if (this.id > 0) {
      this.GetRole();
    }
    this.ComboLoad('UserMaster');
  }

  GetRole() {
    this.isDisabled = true;
    this.filter.WebESSRoleMasterId = this.id;
    this.role.GetRole(this.filter).subscribe({
      next: (response) => {
        this.RoleDetail.SelectType = 'U';
        this.RoleDetail.RoleName = response.Table[0].RoleName;
        this.RoleDetail.UserMasterIdObj = response.Table1.map((e: any) => e.UserMasterId);
        console.log("role", this.RoleDetail.UserMasterIdObj);

        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ComboLoad(Combotype: String) {
    this.isDisabled = true;
    this.combo.ComboLoad({
      'Combotype': Combotype,
      'BranchId': 0,
      'ClientId': 0,
      'SiteId': 0,
      'DesignationId': 0,
      'EmpType': null,
      'StateId': 0,
      'DistrictId': 0,
      'EmpMasterID': 0
    }).subscribe({
      next: (response) => {

        if (Combotype == 'UserMaster') {
          this.Users = response.ComboLoad;
          this.UsersFilter = response.ComboLoad;

        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  async SaveRole() {
    await this.common.getPageRights();
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
      windowClass: 'confirmation-modal'
    });

    modalRef.componentInstance.Message = 'Do you want save?'
    modalRef.result.then((result: any) => {
      if ((this.id == 0 && this.common.PageRight.IsAdd) || (this.id > 0 && this.common.PageRight.IsEdit)) {
        if (result) {
          this.isDisabled = true;
          this.RoleDetail.WebESSRoleMasterId = this.id;
          this.RoleDetail.UserMasterId = this.RoleDetail.UserMasterIdObj.toString();
          this.RoleDetail.WebESSRoleMasterId = this.id;
  
          this.role.SaveRole(this.RoleDetail).subscribe({
            next: (response) => {
              if (response.Error_Code == '191' || response.Error_Code == '192') {
                this.activeModal.close(true);
                this.toast.show({ message: response.Error_Message, type: toastTypeEnum.success });
              }
              else {
                this.toast.show({ message: response.Error_Message, type: toastTypeEnum.warning });
              }
              this.isDisabled = false;
            },
            complete: () => { },
            error: (error) => {
              this.isDisabled = false;
            },
          });
        }
      } else {
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    }).catch(() => {
      // Modal dismissed
    });
  }

  close() {
    this.activeModal.close();
  }

}
